import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../../utils/pixel';
interface ButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
  onClick?: () => void;
}
export function Button({
  children,
  href = '#',
  className = '',
  onClick
}: ButtonProps) {
  const content = <motion.div whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`inline-flex items-center justify-center px-6 py-3.5 md:px-8 md:py-4 text-base md:text-lg font-medium text-white bg-purple-600 rounded-full shadow-[0_0_20px_rgba(124,58,237,0.3)] hover:bg-purple-700 hover:shadow-[0_0_25px_rgba(124,58,237,0.5)] transition-all duration-300 ${className}`} data-id="element-380">
      {children}
    </motion.div>;
  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      onClick();
      return;
    }
    if (href.startsWith('#')) {
      e.preventDefault();
      const el = document.querySelector(href);
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
    if (href.startsWith('http')) {
      trackAddToCart();
    }
  };
  const isExternal = href.startsWith('http');
  return <a href={href} onClick={handleClick} className="focus:outline-none inline-block" {...isExternal ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} data-id="element-381">
      {content}
    </a>;
}